import { BenefitCardOrderSubmit } from "components/BenefitCardOrderSubmit/BenefitCardOrderSubmit";
import { useAtomValue } from "jotai";
import {
  orderedImplementationsAtom,
  selectedCompanyState,
} from "store/UIHrPage";
import { useHrImplementationList } from "../../ManagePageView/ImplementationsHrView/useHrImplementationList";

export function HrImplementationOrderButton() {
  const selectedCompany = useAtomValue(selectedCompanyState);

  const benefitKey = `${selectedCompany?.countryCode}-${selectedCompany?.clientInternalNumberGos}-implementation`;

  const {
    implementedBenefits,
    implementationLoading,
    implementationRefetching,
  } = useHrImplementationList();

  return (
    <BenefitCardOrderSubmit
      disabled={implementationLoading || implementationRefetching}
      itemList={implementedBenefits || []}
      settingKey={benefitKey}
      orderedAtom={orderedImplementationsAtom}
      itemIdProperty="benefitImplementationTag"
    />
  );
}
